import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  snackbarSuccess: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #85DFA9",
  },
  snackbarError: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #F11023",
  },
  alert: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    alignItems: "center",
    width: "100%",
    padding: "15px 16px",
    lineHeight: "24px",
    "&.MuiAlert-standardSuccess": {
      "& .MuiAlert-icon": {
        color: "#0ABF52",
        fontSize: theme.typography.pxToRem(24),
      },
    },
    "&.MuiAlert-standardError": {
      "& .MuiAlert-icon": {
        color: "#F11023",
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },
}));
